import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { takeSquabReturn } from "@/lib/squab";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash || "";
    const search = location.search || window.location.search || "";
    const match = hash.match(/session_id=([^&]+)/) || search.match(/session_id=([^&]+)/);
    if (!match) {
      toast.error("Google sign-in was cancelled or invalid. Please try again.");
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        const destination = takeSquabReturn("/profile");
        window.history.replaceState(null, "", destination);
        toast.success(`Welcome${data.name ? ", " + data.name.split(" ")[0] : ""}!`);
        navigate(destination);
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="font-mono-caps text-xs text-primary animate-pulse">Signing you in…</p>
    </div>
  );
}
